export default __webpack_public_path__ + "static/media/ProductPageImage04.dbfe9bb9.jpg";